import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { SignatureType } from "@/common/types/signature";

export async function analysisSignatureList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/analysis/signature/list${queryString}`,
  );
}

export async function analysisSignatureGet(
  account_id: string,
  signature_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/analysis/signature/${signature_id}/show`,
  );
}

export async function analysisSignatureCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    analysis_id: string;
    type: string;
    name: string | null;
    document_type: string | null;
    document_name: string | null;
    document_number: string | null;
    signature: string | null;
    description: string | null;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/analysis/signature/create`,
    payload,
  );
}

export async function analysisSignaturePatch(
  account_id: string,
  signature_id: string,
  payload: Partial<SignatureType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/analysis/signature/${signature_id}/patch`,
    {
      payload,
    },
  );
}

export async function analysisSignatureDelete(
  account_id: string,
  signature_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/analysis/signature/${signature_id}/delete`,
  );
}
